export enum PizzaSideEnum {
    right = 1,
    left = 2,
    all = 3,
}
